import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App'
import {StateProvider} from './context/store.js';


// This is the ID of the div in your index.html file

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
  	<StateProvider>
    	<App />
    </StateProvider>
  </StrictMode>,
);


